<div class="row m-2">
    <div class="col-sm-8 col-md-8">
        <div class="row">
            <div class="col-md-6">
                <h2>{{ viewDate | calendarDate:(view + 'ViewTitle'):'en' }}</h2>
            </div>
            <div class="col-md-6 text-end">
                <div class="btn-group">
                    <button class="cal_perv_btn" mat-raised-button color="primary" mwlCalendarPreviousView [view]="view"
                        [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay(); yearmonth(viewDate)">
                        Previous
                    </button>
                    <button mat-raised-button mwlCalendarToday [(viewDate)]="viewDate"
                        (viewDateChange)="yearmonth(viewDate)">
                        Today
                    </button>
                    <button class="cal_next_btn" mat-raised-button color="primary" mwlCalendarNextView [view]="view"
                        [(viewDate)]="viewDate" (viewDateChange)="closeOpenMonthViewDay(); yearmonth(viewDate)">
                        Next
                    </button>
                </div>
            </div>
        </div>
        <div [ngSwitch]="view">
            <mwl-calendar-month-view *ngSwitchCase="'month'" [viewDate]="viewDate" [events]="events" [refresh]="refresh"
                (eventTimesChanged)="eventTimesChanged($event)" [cellTemplate]="customCellTemplate">
            </mwl-calendar-month-view>
        </div>
        <ng-template #customCellTemplate let-day="day" let-openDay="openDay" let-locale="locale"
            let-tooltipPlacement="tooltipPlacement" let-highlightDay="highlightDay" let-unhighlightDay="unhighlightDay"
            let-eventClicked="eventClicked" let-tooltipTemplate="tooltipTemplate"
            let-tooltipAppendToBody="tooltipAppendToBody">
            <div class="calendardata_box">
                <div class="d-flex justify-content-center">
                    <span class="cal-day-number">{{ day.date | calendarDate:'monthViewDayNumber':locale }}</span>
                </div>
                <!-- <ng-container *ngIf="day?.events[0]?.meta.start_time">
          <div class="cal-day-notes p-2">
            <p class="m-0"><small>In - {{day?.events[0]?.meta.start_time}} </small></p>
            <p class="m-0"><small>Out - {{day?.events[0]?.meta.end_time}}</small></p>
          </div>
        </ng-container> -->
                <ng-container [ngSwitch]="day?.events[0]?.meta.daytype">
                    <div *ngSwitchCase="'ABSENT'" class="cal-day-notes p-2">
                        <p class="m-0 absent_show_data text-center"><small>{{day?.events[0]?.meta.daytype}}</small></p>
                        <!-- <p class="m-0 text-center"><small>{{day?.events[0]?.meta.notes}} </small></p> -->
                    </div>
                    <div *ngSwitchCase="'HOLIDAY'" class="cal-day-notes p-2">
                        <p class="m-0 holiday_show_data text-center"><small>{{day?.events[0]?.meta.daytype}} </small>
                        </p>
                        <!-- <p class="m-0 text-center"><small>{{day?.events[0]?.meta.notes}} </small></p> -->
                    </div>
                    <div *ngSwitchCase="'WEEKOFF'" class="cal-day-notes p-2">
                        <!-- <p class="m-0 holiday_show_data text-center"><small>{{day?.events[0]?.meta.daytype}} </small></p> -->
                        <p class="m-0 text-center"><small>{{day?.events[0]?.meta.notes}} </small></p>
                    </div>
                </ng-container>
                <div class="d-flex justify-content-between">
                    <div class="text-start attendance_view_dot p-2">
                        <ng-container *ngFor="let event of day.events">
                            <ng-container *ngIf="event.meta.status == 'PRESENT' || event.meta.status == 'ABSENT'">
                                <div class="cal-event" [style.backgroundColor]="event.color.primary"
                                    [ngClass]="event?.cssClass"
                                    [mwlCalendarTooltip]="event.title | calendarEventTitle:'monthTooltip':event"
                                    [tooltipPlacement]="tooltipPlacement" [tooltipEvent]="event"
                                    [tooltipTemplate]="tooltipTemplate" [tooltipAppendToBody]="tooltipAppendToBody">
                                </div>
                            </ng-container>
                            <!-- <ng-template #absent_content>
                            <div class="attendance_view_absent"><span class="m-0">ABSENT</span>
                            </div>
                        </ng-template> -->
                        </ng-container>
                    </div>
                    <!-- <div>
                        <i class="fa-solid fa-ellipsis-vertical" [matMenuTriggerFor]="menu" aria-hidden="false" aria-label="more option"
                        [ngStyle]="{'color':'white'}"></i>
                    <mat-menu #menu="matMenu">
                        <small mat-menu-item>Apply Leave</small>
                        <small mat-menu-item>Apply Comp Off</small>
                        <small mat-menu-item>Apply Permission</small>
                    </mat-menu>
                </div> -->
                </div>
            </div>
        </ng-template>
        <div class="">
            <div *ngFor="let items of Representaion_data" class="representation">
                <div class="representation_color" [ngStyle]="{'background-color': items.color}"></div>
                <div class="representation_text">{{items.title}}</div>
            </div>
        </div>
    </div>
    <div class="col-sm-4 col-md-4">
        <div class="row">
            <div class="col-sm-6">
                <div class="bg-green">
                    <div class="px-2 py-2">
                        <h2 class="m-0">{{total_present_days}}</h2>
                        <p class="m-0">Present Days</p>
                    </div>
                </div>
            </div>
            <div class="col-sm-6">
                <div class="bg-pink">
                    <div class="px-2 py-2">
                        <h2 class="m-0">{{total_absent_days}}</h2>
                        <p class="m-0">Absent Days</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-grey mt-2">
            <div class="px-2 py-4">
                <div>
                    <small>Attendance Percentage</small>
                </div>
                <div class="mt-2">
                    <mat-progress-bar mode="determinate" [color]="color"
                        [value]="attendance_percentage"></mat-progress-bar>
                </div>
            </div>
        </div>
    </div>
</div>